import * as pdfjsLib from "pdfjs-dist";

pdfjsLib.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.mjs",
  import.meta.url
).toString();

const PDF_RESOLUTION = 1_500_000;
const MAX_PDF_SCALE = 5.5;

export async function getImagesFromPDF(file: string): Promise<string[]> {
  const pdf = await pdfjsLib.getDocument({
    url: file,
    cMapUrl: "/cmaps/",
    cMapPacked: true,
    standardFontDataUrl: "/standard_fonts/",
  }).promise;

  const pages = pdf.numPages;
  const images: string[] = [];

  for (let i = 1; i <= pages; i++) {
    const page = await pdf.getPage(i);
    const [, , w, h] = page.view;
    const scale = Math.min(Math.sqrt(PDF_RESOLUTION / (w * h)), MAX_PDF_SCALE);
    const viewport = page.getViewport({ scale });

    const canvas = document.createElement("canvas");
    canvas.width = viewport.width;
    canvas.height = viewport.height;

    await page.render({
      canvasContext: canvas.getContext("2d")!,
      viewport,
    }).promise;

    images.push(canvas.toDataURL());
  }

  return images;
}
